/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';

export const ACCEPT_USER_REQUEST = 'ACCEPT_USER_REQUEST';
export const ACCEPT_USER_SUCCESS = 'ACCEPT_USER_SUCCESS';
export const ACCEPT_USER_FAILURE = 'ACCEPT_USER_FAILURE';

/**
 * Accept the user from admin view.
 *
 * @param {string} token - User auth token.
 * @param {Object} data - The user object.
 * @param {string} data.user_id - The user ID.
 * @param {(CLIENT|MODEL|HEAD_STYLIST|PHOTOGRAPHER|INFLUENCER|CLOTHING_STYLIST)} data.skill - The skill type.
 * @param {string} data.talent_rates - A list of comma seperated rates.
 * @param {string} data.talent_types - A list of comma seperated types.
 *
 * @return {Object}
 */
export const acceptUser = (token, data) => ({
  [API]: {
    endpoint: '/admin/user/accept',
    method: 'POST',
    body: data,
    token,
    types: [ACCEPT_USER_REQUEST, ACCEPT_USER_SUCCESS, ACCEPT_USER_FAILURE],
  },
});

export const REJECT_USER_REQUEST = 'REJECT_USER_REQUEST';
export const REJECT_USER_SUCCESS = 'REJECT_USER_SUCCESS';
export const REJECT_USER_FAILURE = 'REJECT_USER_FAILURE';

/**
 * Reject the user from admin view.
 *
 * @param {string} token - User auth token.
 * @param {Object} data - The user object.
 * @param {string} data.user_id - The user ID.
 *
 * @return {Object}
 */
export const rejectUser = (token, data) => ({
  [API]: {
    endpoint: '/admin/user/reject',
    method: 'POST',
    body: data,
    token,
    types: [REJECT_USER_REQUEST, REJECT_USER_SUCCESS, REJECT_USER_FAILURE],
  },
});

export const ADD_ROLE_REQUEST = 'ADD_ROLE_REQUEST';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ADD_ROLE_FAILURE = 'ADD_ROLE_FAILURE';

/**
 * Reject the user from admin view.
 *
 * @param {string} token - User auth token.
 * @param {Object} data - The user object.
 * @param {string} data.user_id - The user ID.
 * @param {(CLIENT|MODEL|HEAD_STYLIST|PHOTOGRAPHER|INFLUENCER|CLOTHING_STYLIST)} data.role_type - The new role type.
 * @param {string} data.agency_id - Optional agency_id.
 *
 * @return {Object}
 */
export const addRole = (token, data) => ({
  [API]: {
    endpoint: '/admin/user/addrole',
    method: 'POST',
    body: data,
    token,
    types: [ADD_ROLE_REQUEST, ADD_ROLE_SUCCESS, ADD_ROLE_FAILURE],
  },
});

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

/**
 * Delete the user from admin view.
 *
 * @param {string} token - User auth token.
 *
 * @return {Object}
 */
export const deleteUser = (token, data) => ({
  [API]: {
    endpoint: '/admin/user/delete',
    method: 'POST',
    body: data,
    token,
    types: [DELETE_USER_REQUEST, DELETE_USER_SUCCESS, DELETE_USER_FAILURE],
  },
});
